module.exports = __webpack_public_path__ + "img/pet@2x.cd68136f.png";